// @ts-nocheck
const infinity = Math.pow(10, 10); // Max positive number
// const infinity = "All"; // Max positive number
export { infinity };